export const creditDeniedText = {
  canSelectNewPaymentMethod:
    'Infelizmente não podemos conceder o crédito, mas você ainda pode realizar o pagamento de outras formas.',
  cannotSelectNewPaymentMethod: 'Infelizmente não podemos conceder o crédito.',
}
